import React from 'react';
import './tiggbee-contact-us.css';
import { Link } from "gatsby";

export class TiggbeeNoBackgroundContactUs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        }
    }

    render() {
        const html = <>
            <div className={`contact-us-container${(this.props.isSmallContainer)?(' contact-us-small-container'):('')}`}
                style={{
                    backgroundColor: '#5F6670'
                }}
            >
                <div className='contact-us-title'>{this.props.titleElement}</div>
                {
                    (this.props.isHideButton)?(
                        <></>
                    ):(
                        <Link className='contact-us-button' to='/contact-us-page'>Contact Us</Link>
                    )
                }
            </div>
        </>;
        return (
            html
        );
    }
}